import React, { useContext, useCallback } from 'react';
import { bool, func, string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { extend } from '@thd-nucleus/data-sources';
import * as analytics from '../../analytics';
import { ProductDetailsContext } from '../ProductDetailsContext';
import { ProductDetailsBadge } from './ProductDetailsBadge.component';

const ProductDetailsTitle = (props) => {

  const { product, itemId, configuredProductLabel } = useContext(ProductDetailsContext);
  const { channel } = useContext(ExperienceContext);

  const publish = useCallback(() => {
    analytics.track('click', {
      element: 'product name',
    });
  }, []);
  const handleClick = useCallback((event) => {
    const { onClick } = props;
    publish();
    if (onClick) {
      onClick(event, { product });
    }
  }, [product]);

  const labelHtml = useCallback(({ product: localProduct, configuredProductLabel: localConfigLabel }) => {
    const { link, pageType, badge } = props;
    const isMobile = channel === 'mobile';
    const titleClassName = isMobile && pageType === 'PEP'
      ? 'product-details__title--mobile'
      : 'product-details__title';
    const { identifiers } = localProduct;
    const titleString = localConfigLabel || identifiers.productLabel;
    const ProductTitle = () => (
      <h1 className={titleClassName}>
        {badge && <ProductDetailsBadge itemId={itemId} />}
        {titleString}
      </h1>
    );

    if (link) {
      return (
        <a href={identifiers.canonicalUrl} onClick={handleClick} className="product-details__click-title">
          <ProductTitle />
        </a>
      );
    }
    return <ProductTitle />;
  }, [product]);

  if (!product) return null;
  return (
    <span className="product-title">
      {labelHtml({ ...props, product, configuredProductLabel })}
    </span>
  );
};

ProductDetailsTitle.propTypes = {
  badge: bool,
  link: bool,
  onClick: func,
  pageType: string,
};

ProductDetailsTitle.defaultProps = {
  badge: false,
  link: false,
  onClick: null,
  pageType: 'PEP',
};

ProductDetailsTitle.dataModel = extend(ProductDetailsBadge);

export default ProductDetailsTitle;
